export default __webpack_public_path__ + "static/media/cuadro.24daa22b.svg";